
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'

export const STPPreventiveSewerageQuality_B_ExportData = (props) => {
    const { ExcelData, name, FromDate, ToDate } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '46%' }}>

                <h5><span>&emsp;</span></h5>

                {/* <h4 style={{ textAlign: 'center', fontSize: 16 }}>{name}</h4> */}
                {/* <h4 style={{ textAlign: 'center', fontSize: 16 }}>Navi Mumbai Muncipal Corporation</h4>
                <h4 style={{ textAlign: 'center', fontSize: 16 }}>STP Maintenance Department</h4>
                <h4 style={{ textAlign: 'center', fontSize: 16 }}>Project Name - {ExcelData && ExcelData.length > 0 ? ExcelData[0].projectName : '-'}</h4>
                <h4 style={{ textAlign: 'center', fontSize: 16 }}>Report Name - {name}</h4>
                <h4 style={{ textAlign: 'center', fontSize: 16 }}>
                    Report From Date - {FromDate ? moment(FromDate).format('DD-MM-YYYY') : '-'}
                    <span>&emsp;</span>
                    | To Date - {ToDate ? moment(ToDate).format('DD-MM-YYYY') : '-'}
                </h4> */}

                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={18} style={{ textAlign: 'center', fontSize: 16 }}>Navi Mumbai Muncipal Corporation</th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={18} style={{ textAlign: 'center', fontSize: 16 }}>STP Maintenance Department</th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={18} style={{ textAlign: 'center', fontSize: 16 }}>Project Name - {ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table[0].projectName : '-'}</th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={18} style={{ textAlign: 'center', fontSize: 16 }}>Report Name - {name}</th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={18} style={{ textAlign: 'center', fontSize: 16 }}>
                        Report From Date - {FromDate ? moment(FromDate).format('DD-MM-YYYY') : '-'}
                        <span>&emsp;</span>
                        | To Date - {ToDate ? moment(ToDate).format('DD-MM-YYYY') : '-'}
                    </th>
                </tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                        <th className="sr_no_col" rowSpan="2" style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                        <th rowSpan="2">Date</th>
                        <th colSpan="4" className='new_grid'>MLSS (Mg / L)</th>
                        <th colSpan="4" className='new_grid'>MLVSS (Mg / L)</th>
                        <th colSpan="4" className='new_grid'>SV30</th>
                        <th colSpan="4" className='new_grid' style={{ textAlign: "center", borderRight: "1px solid black" }}>SV1 (MLD)</th>
                    </tr>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid white" }}>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 1</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 2</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 3</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 4</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 1</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 2</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 3</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 4</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 1</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 2</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 3</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 4</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 1</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 2</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Tank 3</th>
                        <th style={{ whiteSpace: 'nowrap', borderRight: "1px solid black" }}>Tank 4</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.length > 0 ? ExcelData.map((item) => {
                            return (
                                <tr style={{ width: '100%', border: "1px solid black" }}>
                                    <td style={{ textAlign: "center" }}>{item.srNo ? item.srNo : '-'}</td>
                                    <td>{item.readingDate ? item.readingDate : '-'}</td>
                                    <td>{item.mlsS_Mg_L_Tank_1 ? item.mlsS_Mg_L_Tank_1 : '0'}</td>
                                    <td>{item.mlsS_Mg_L_Tank_2 ? item.mlsS_Mg_L_Tank_2 : '0'}</td>
                                    <td>{item.mlsS_Mg_L_Tank_3 ? item.mlsS_Mg_L_Tank_3 : '0'}</td>
                                    <td>{item.mlsS_Mg_L_Tank_4 ? item.mlsS_Mg_L_Tank_4 : '0'}</td>
                                    <td>{item.mlvsS_Mg_L_Tank_1 ? item.mlvsS_Mg_L_Tank_1 : '0'}</td>
                                    <td>{item.mlvsS_Mg_L_Tank_2 ? item.mlvsS_Mg_L_Tank_2 : '0'}</td>
                                    <td>{item.mlvsS_Mg_L_Tank_3 ? item.mlvsS_Mg_L_Tank_3 : '0'}</td>
                                    <td>{item.mlvsS_Mg_L_Tank_4 ? item.mlvsS_Mg_L_Tank_4 : '0'}</td>
                                    <td>{item.sV30_Tank_1 ? item.sV30_Tank_1 : '0'}</td>
                                    <td>{item.sV30_Tank_2 ? item.sV30_Tank_2 : '0'}</td>
                                    <td>{item.sV30_Tank_3 ? item.sV30_Tank_3 : '0'}</td>
                                    <td>{item.sV30_Tank_4 ? item.sV30_Tank_4 : '0'}</td>
                                    <td>{item.svI_Tank_1 ? item.svI_Tank_1 : '0'}</td>
                                    <td>{item.svI_Tank_2 ? item.svI_Tank_2 : '0'}</td>
                                    <td>{item.svI_Tank_3 ? item.svI_Tank_3 : '0'}</td>
                                    <td>{item.svI_Tank_4 ? item.svI_Tank_4 : '0'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>
            </table>
        </div >
    )
}